export default "__VITE_ASSET__DYZXhmbk__"